export class DynamicLibraryFilter {
  country: string[];
  regulator: string[];
  pubType: string[];
  ruleTopic: string[];
  title: string[];
  geography: string[];
  SearchQuery: string[];
  topicNegativeFilter: string[];
  titleNegativeFilter: string[];
  constructor() {
    this.country = [];
    this.regulator = [];
    this.pubType = [];
    this.ruleTopic = [];
    this.title = [];
    this.geography=[];
    this.SearchQuery = [];
    this.topicNegativeFilter = [];
    this.titleNegativeFilter = [];
  }
}
